import { ModalProps } from "shared/types/modal";
import ConfirmationModal from "shared/modal/confirmation";

interface Props extends ModalProps {
  loading?: boolean;
  handleSubmit: () => void;
}

// Starting work flips the revision to In Progress and emails the client, and
// nothing in the portal puts it back — so both entry points confirm first.
const StartWorkingConfirmationModal = ({
  loading,
  show,
  handleClose,
  handleSubmit,
}: Props) => (
  <ConfirmationModal
    show={show}
    handleClose={handleClose}
    handleSubmit={handleSubmit}
    title="Start working on this revision?"
    subtitle="This marks the next revision as In Progress and emails the client and any co-designers. You can't undo this from the portal."
    actionButtonText="Start Working"
    cancelButtonText="Cancel"
    modalType="confirmation"
    loading={loading}
  />
);

export default StartWorkingConfirmationModal;
